// import React, { useEffect, useState } from "react";
// // import "./JobDetailTables.css"; // optional: include your CSS styling
// import styles from './JobDetailTables.module.css';

// const JobDetailTables = ({ jobId }) => {
//   const [tables, setTables] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;

//     fetch(`${API_URL}/jobs/${jobId}`)
//       .then((res) => res.json())
//       .then((data) => {
//         setTables(data.jobDetailTable || []);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch job details:", err);
//         setLoading(false);
//       });
//   }, [jobId]);

//   if (loading) return <p>Loading job details...</p>;

//   if (!tables || tables.length === 0) return null;

//   return (
//     <div className="job-detail-table-wrapper">
//       {tables.map((table, tableIndex) => (
//         <div className="job-detail-table-block" key={table._id || tableIndex}>
//           {/* {table.heading && <h4 className="job-detail-heading">{table.heading}</h4>} */}
//           <div className="job-detail-heading">{table.heading}</div>
//           <div className="table-responsive">
//             <table className="styled-table">
//               <thead>
//                 <tr>
//                   {table.columns.map((col, colIdx) => (
//                     <th key={colIdx}>{col}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {table.rows.map((row, rowIdx) => (
//                   <tr key={rowIdx}>
//                     {table.columns.map((col, colIdx) => (
//                       <td key={colIdx}>
//                         {row[col] !== undefined ? row[col] : "-"}
//                       </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default JobDetailTables;





// import React, { useEffect, useState } from "react";
// import styles from './JobDetailTables.module.css';

// const JobDetailTables = ({ jobId }) => {
//   const [tables, setTables] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;

//     fetch(`${API_URL}/jobs/${jobId}`)
//       .then((res) => res.json())
//       .then((data) => {
//         setTables(data.jobDetailTable || []);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch job details:", err);
//         setLoading(false);
//       });
//   }, [jobId]);

//   if (loading) return <p>Loading job details...</p>;
//   if (!tables || tables.length === 0) return null;

//   return (
//     <div className={styles.wrapper}>
//       {tables.map((table, tableIndex) => (
//         <div className={styles.block} key={table._id || tableIndex}>
//           {table.heading && (
//             <div className={styles.heading}>{table.heading}</div>
//           )}
//           <div className={styles.responsive}>
//             <table className={styles.table}>
//               <thead>
//                 <tr>
//                   {table.columns.map((col, colIdx) => (
//                     <th key={colIdx} className={styles.th}>{col}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {table.rows.map((row, rowIdx) => (
//                   <tr key={rowIdx}>
//                     {table.columns.map((col, colIdx) => (
//                       <td key={colIdx} className={styles.td}>
//                         {row[col] !== undefined ? row[col] : "-"}
//                       </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default JobDetailTables;





// import React, { useEffect, useState } from "react";
// import styles from './JobDetailTables.module.css';

// const JobDetailTables = ({ jobId }) => {
//   const [tables, setTables] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;

//     fetch(`${API_URL}/jobs/${jobId}`)
//       .then((res) => res.json())
//       .then((data) => {
//         setTables(data.jobDetailTable || []);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch job details:", err);
//         setLoading(false);
//       });
//   }, [jobId]);

//   if (loading) return <p>Loading job details...</p>;
//   if (!tables || tables.length === 0) return null;

//   return (
//     <div className={styles.wrapper}>
//       {tables.map((table, tableIndex) => (
//         <div className={styles.block} key={table._id || tableIndex}>
//           {table.heading && (
//             <div className={styles.heading}>{table.heading}</div>
//           )}
//           <div className={styles.responsive}>
//             <table className={styles.table}>
//               <thead>
//                 <tr>
//                   {table.columns.map((col, colIdx) => (
//                     <th key={colIdx} className={styles.th}>{col}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {table.rows.map((row, rowIdx) => (
//                   <tr key={rowIdx}>
//                     {table.columns.map((col, colIdx) => (
//                       <td key={colIdx} className={styles.td}>
//                         {row[col] !== undefined ? (
//                           <div dangerouslySetInnerHTML={{ __html: row[col] }} />
//                         ) : (
//                           "-"
//                         )}
//                       </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default JobDetailTables;








import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // ✅ Import useParams
import styles from './JobDetailTables.module.css';

const JobDetailTables = () => {
  const { slug } = useParams(); // ✅ Get slug from URL
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;

    fetch(`${API_URL}/jobs/slug/${slug}`) // ✅ Fetch by slug
      .then((res) => res.json())
      .then((data) => {
        setTables(data.jobDetailTable || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch job details:", err);
        setLoading(false);
      });
  }, [slug]); // ✅ Depend on slug

  if (loading) return <p>Loading job details...</p>;
  if (!tables || tables.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      {tables.map((table, tableIndex) => (
        <div className={styles.block} key={table._id || tableIndex}>
          {table.heading && (
            <div className={styles.heading}>{table.heading}</div>
          )}
          <div className={styles.responsive}>
            <table className={styles.table}>
              <thead>
                <tr>
                  {table.columns.map((col, colIdx) => (
                    <th key={colIdx} className={styles.th}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {table.rows.map((row, rowIdx) => (
                  <tr key={rowIdx}>
                    {table.columns.map((col, colIdx) => (
                      <td key={colIdx} className={styles.td}>
                        {row[col] !== undefined ? (
                          <div dangerouslySetInnerHTML={{ __html: row[col] }} />
                        ) : (
                          "-"
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default JobDetailTables;
